import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerPaymentMethodDataPropsAndroid from './../../../common/primerPaymentMethodDataProps.mdx';
import PaymentCreationHandlerAndroid from './../../../common/paymentCreationDecisionHandler.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`This method will be called just before the payment gets created, and lets you decide whether you want to proceed
with the payment creation.`}</p>
    <Callout emoji="⚠️" mdxType="Callout">
      <p>{`This method will be called only when using the `}<inlineCode parentName="p">{`PrimerPaymentHandling.AUTO`}</inlineCode>{` `}<a parentName="p" {...{
          "href": "./../../../common/settings/primerSettings#properties"
        }}>{`flow`}</a>{`.
Please note, that if you `}<inlineCode parentName="p">{`override`}</inlineCode>{` this method, you `}<strong parentName="p">{`must`}</strong>{` call one of the decisionHandler's methods.`}</p>
    </Callout>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`fun onBeforePaymentCreated(
  paymentMethodData: PrimerPaymentMethodData,
  decisionHandler: PrimerPaymentCreationDecisionHandler
)
`}</code></pre>
    <h3>{`Parameters`}</h3>
    <Group mdxType="Group">
	<Item title='paymentMethodData' label='PrimerPaymentMethodData' label='Required' mdxType="Item">
		<PrimerPaymentMethodDataPropsAndroid mdxType="PrimerPaymentMethodDataPropsAndroid" />
	</Item>
	<PaymentCreationHandlerAndroid mdxType="PaymentCreationHandlerAndroid" />
    </Group>
    <h4>{`Example`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`  class CheckoutActivity : AppCompatActivity() {
    // 👇 Add this
    private val listener = object : PrimerHeadlessUniversalCheckoutListener {
      // 👇 Add this
      override fun onBeforePaymentCreated(
        paymentMethodData: PrimerPaymentMethodData,
        decisionHandler: PrimerPaymentCreationDecisionHandler
      ) {
        decisionHandler.continuePaymentCreation()
      }
    }
  }
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      